<template>
    <div class="card stretch stretch-full">
        <div class="card-header">
            <h5 class="card-title"><span class="text-danger">[{{ stock[0]?.warehouse_name || '' }}]</span> <br> <span
                    class="text-danger">[{{ stock[0]?.medicine_name || '' }}]</span><br> SKT Bazlı Liste</h5>
            <div class="card-header-action">
                <div class="card-header-btn">
                    <div data-bs-toggle="tooltip" title="Kapat">
                        <button @click="closeCard" class="avatar-text avatar-xs bg-danger">
                        </button>
                    </div>

                    <div data-bs-toggle="tooltip" title="Yenile">
                        <button @click="fetchStock()" class="avatar-text avatar-xs bg-warning" data-bs-toggle="refresh">
                        </button>
                    </div>
                    <div data-bs-toggle="tooltip" title="Ekranı Kapla/Küçült">
                        <a href="javascript:void(0);" class="avatar-text avatar-xs bg-success" data-bs-toggle="expand">
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body custom-card-action p-0">
            <div class="table-responsive">
                <table class="table mb-0">
                    <thead>
                        <tr>
                            <th scope="col">Son Kullanma Tarihi</th>
                            <th scope="col" class="text-end">Miktar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="stock.length === 0 && !loading" class="text-gray-500">
                            <td colspan="4">Kayıt bulunamadı.</td>
                        </tr>
                        <tr v-if="loading" class="text-gray-500">
                            <td colspan="4">Yükleniyor...</td>
                        </tr>
                        <tr v-for="item in stock"
                            :key="`${item.warehouse_id}-${item.medicine_id}-${item.expiration_date}`">
                            <td>{{ item.expiration_date || 'Yok' }}</td>
                            <td class="text-end">{{ item.quantity }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WarehouseStockListByExpirationDate',
    props: {
        warehouseId: {
            type: [String, Number],
            default: null,
        },
        medicineId: {
            type: [String, Number],
            default: null,
        },
    },
    data() {
        return {
            stock: [],
            loading: false,
        }
    },
    watch: {
        warehouseId: 'fetchStock',
        medicineId: 'fetchStock',
    },
    methods: {
        closeCard() {
            this.$emit('close-card')
        },
        async fetchStock() {
            this.loading = true
            try {
                const params = {}

                if (this.warehouseId) params.warehouse_id = this.warehouseId
                if (this.medicineId) params.medicine_id = this.medicineId

                console.log('API parametreleri:', params);


                const response = await this.$axios.get(`warehouse-stock-by-expiration/?${new URLSearchParams(params).toString()}`)
                this.stock = response.data
            } catch (error) {
                console.error('API hatası:', error)
                this.stock = []
            } finally {
                this.loading = false
            }
        }
    },
    mounted() {
        this.fetchStock()
    }
}
</script>